import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddApiRapidValueService {
  addEditPropertySubjectData: BehaviorSubject<'addEditPropertyData' | null> = new BehaviorSubject(null);
  propertyDataSubjectData: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  addEditMotorSubjectData: BehaviorSubject<'addEditMotorData' | null> = new BehaviorSubject(null);
  addEditMxAccountBalanceSubjectData: BehaviorSubject<'addEditMxAccountBalanceData' | null> = new BehaviorSubject(null);
  vehicleDataSubjectData: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  mxAccountBalanceSubjectData: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
  propertyFeedsSubjectData: BehaviorSubject<{ [key: string]: any }> = new BehaviorSubject<{ [key: string]: any }>({});
  propertyGeneralSubjectData: BehaviorSubject<{ [key: string]: any }> = new BehaviorSubject<{ [key: string]: any }>({});
  propertyFeedsMapData: Map<string, BehaviorSubject<{ [key: string]: any }>> = new Map();
  propertyGeneralMapData: Map<string, BehaviorSubject<{ [key: string]: any }>> = new Map();
  apiIndicatorsSubjectData: BehaviorSubject<string> = new BehaviorSubject('');
  copyDataFromLiveFeedsSubjectData :  BehaviorSubject<boolean> = new BehaviorSubject(false)

  setPropertyDataFromLiveFeeds(data: { [key: string]: any }, templateId?: string) {
    if (templateId) {
      if (!this.propertyFeedsMapData.has(templateId)) {
        this.propertyFeedsMapData.set(templateId, new BehaviorSubject(data));
      } else {
        this.propertyFeedsMapData.get(templateId)!.next(data);
      }
    } else {
      this.propertyFeedsSubjectData.next(data);
    }
  }

  getPropertyDataFromLiveFeeds(templateId?: string): Observable<{ [key: string]: any }> {
    if (templateId) {
      if (!this.propertyFeedsMapData.has(templateId)) {
        this.propertyFeedsMapData.set(templateId, new BehaviorSubject<{ [key: string]: any }>({}));
      }
      return this.propertyFeedsMapData.get(templateId)!.asObservable();
    } else {
      return this.propertyFeedsSubjectData.asObservable();
    }
  }

  clearPropertyDataFromLiveFeedsData(templateId?: string) {
    if (templateId) {
      this.propertyFeedsMapData.delete(templateId);
    } else {
      this.propertyFeedsSubjectData.next({});
    }
  }

  setPropertyDataFromGeneral(data: { [key: string]: any }, templateId?: string) {
    if (templateId) {
      if (!this.propertyGeneralMapData.has(templateId)) {
        this.propertyGeneralMapData.set(templateId, new BehaviorSubject(data));
      } else {
        this.propertyGeneralMapData.get(templateId)!.next(data);
      }
    } else {
      this.propertyGeneralSubjectData.next(data);
    }
  }

  getPropertyDataFromGeneral(templateId?: string): Observable<{ [key: string]: any }> {
    if (templateId) {
      if (!this.propertyGeneralMapData.has(templateId)) {
        this.propertyGeneralMapData.set(templateId, new BehaviorSubject<{ [key: string]: any }>({}));
      }
      return this.propertyGeneralMapData.get(templateId)!.asObservable();
    } else {
      return this.propertyGeneralSubjectData.asObservable();
    }
  }

  clearPropertyDataFromGeneralData(templateId?: string) {
    if (templateId) {
      this.propertyGeneralMapData.delete(templateId);
    } else {
      this.propertyGeneralSubjectData.next({});
    }
  }
}
